const COLORS = {
  white: "#ffffff",
  black: "#000000",
  themeBlack: "#1e1e1e",
  border: "#e6e8e9",
  themeRed: "#c22228",
  themeYellow: "#fff102",
  darkYellow: "#e0d300 ",
  background: "#f6f6f6",
  secondBackground: "#f4f4f4",
  darkText: "#212121",
  lightText: "#777777",
  gray: "#a9a9a9",
  lightGray: "#cccccc",
  themeBlue: "#0D77DB",
  themeGreen: "#169543",
  themeOrange: "#EF7417",
};

const FONT = {
  size: {
    xxs: "0.5rem", // 8px
    xs: "0.625rem", // 10px
    sm: "0.75rem", // 12px
    md: "0.875rem", // 14px
    base: "1rem", // 16px
    lg: "1.125rem", // 18px
    xl: "1.25rem", // 20px
    "2xl": "1.5rem", // 24px
    "3xl": "2rem", // 32px
    "4xl": "2.5rem", // 40px
    h3: "1.75rem", // 28px
    h2: "2rem", // 32px
    h1: "2.25rem", // 36px
    display: "2.75rem", // 44px — hero / display headings
  },
};

const SIZES = {};

const SHADOWS = {
  small: {
    shadowColor: COLORS.purple,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 2,
  },
  medium: {
    shadowColor: COLORS.purple,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 5.84,
    elevation: 5,
  },
};

export { COLORS, FONT, SIZES, SHADOWS };
